// Resolve an iOS localization key to its English text for previews.
// Falls back to the raw key when no translation is snapshotted.
import STRINGS from './strings.en.json';

export function t(key) {
  if (key == null || key === '') return '';
  return STRINGS[key] || key;
}

export default STRINGS;
